import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { 
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
} from '../ui/dialog';
import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from '../ui/select';
import { UserCheck, CheckCircle, Loader2 } from 'lucide-react';

const BANK_OPTIONS = [
    { value: 'Cash App', label: 'Cash App' },
    { value: 'Zelle', label: 'Zelle' },
    { value: 'PayPal', label: 'PayPal' },
    { value: 'Stripe', label: 'Stripe' },
    { value: 'American Express', label: 'American Express' },
    { value: 'TD Bank', label: 'TD Bank' },
    { value: 'Capital One', label: 'Capital One' },
    { value: 'Wise', label: 'Wise' },
    { value: 'Bank of America', label: 'Bank of America' },
    { value: 'Chase', label: 'Chase' },
    { value: 'PNC Bank', label: 'PNC Bank' },
    { value: 'Regions Bank', label: 'Regions Bank' },
    { value: 'Efectivo', label: 'Efectivo' },
    { value: 'Transferencia', label: 'Transferencia Bancaria' },
    { value: 'Otro', label: 'Otro' },
];

export const ManualVerifyModal = ({
    isOpen,
    invoice,
    bank,
    setBank,
    sender,
    setSender,
    note,
    setNote,
    isLoading,
    onClose,
    onVerify,
    formatCurrency
}) => {
    return (
        <Dialog open={isOpen} onOpenChange={onClose}>
            <DialogContent className="max-w-md">
                <DialogHeader>
                    <DialogTitle className="text-xl font-semibold text-slate-800 flex items-center gap-2">
                        <UserCheck className="w-5 h-5 text-green-600" />
                        Verificación Manual
                    </DialogTitle>
                </DialogHeader>
                {invoice && (
                    <div className="space-y-4">
                        {/* Invoice Info */}
                        <div className="bg-slate-50 p-4 rounded-lg">
                            <p className="text-sm text-slate-500">Factura</p>
                            <p className="font-semibold text-slate-800">{invoice.name}</p>
                            <p className="text-lg font-bold text-sky-600">{formatCurrency(invoice.amount)}</p>
                        </div>

                        {/* Bank/Source Selection */}
                        <div>
                            <label className="text-sm font-medium text-slate-700 block mb-2">
                                Fuente del Pago
                            </label>
                            <Select value={bank} onValueChange={setBank}>
                                <SelectTrigger data-testid="manual-verify-bank">
                                    <SelectValue placeholder="Seleccionar banco/servicio" />
                                </SelectTrigger>
                                <SelectContent>
                                    {BANK_OPTIONS.map((option) => (
                                        <SelectItem key={option.value} value={option.value}>
                                            {option.label}
                                        </SelectItem>
                                    ))}
                                </SelectContent>
                            </Select>
                        </div>

                        {/* Sender Name */}
                        <div>
                            <label className="text-sm font-medium text-slate-700 block mb-2">
                                Nombre del Remitente
                            </label>
                            <Input
                                value={sender}
                                onChange={(e) => setSender(e.target.value)}
                                placeholder="Nombre de quien envió el pago"
                                data-testid="manual-verify-sender"
                            />
                        </div>

                        {/* Note */}
                        <div>
                            <label className="text-sm font-medium text-slate-700 block mb-2">
                                Nota (opcional)
                            </label>
                            <Input
                                value={note}
                                onChange={(e) => setNote(e.target.value)}
                                placeholder="Ej: Verificado por captura de pantalla"
                                data-testid="manual-verify-note"
                            />
                        </div>

                        {/* Actions */}
                        <div className="flex gap-3 pt-2">
                            <Button
                                variant="outline"
                                onClick={onClose}
                                className="flex-1"
                            >
                                Cancelar
                            </Button>
                            <Button
                                onClick={onVerify}
                                disabled={!bank || isLoading}
                                className="flex-1 bg-green-600 hover:bg-green-700"
                                data-testid="manual-verify-confirm-btn"
                            >
                                {isLoading ? (
                                    <Loader2 className="w-4 h-4 animate-spin mr-2" />
                                ) : (
                                    <CheckCircle className="w-4 h-4 mr-2" />
                                )}
                                Verificar
                            </Button>
                        </div>
                    </div>
                )}
            </DialogContent>
        </Dialog>
    );
};

export default ManualVerifyModal;
